var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteAlt6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM7.8833 7.09253C6.68575 7.89127 5 9.52403 5 12.0818V14.7143C5 15.4244 5.6268 16 6.4 16H9.77556C10.5488 16 11.1756 15.4244 11.1756 14.7143V10.8097C11.1756 10.0997 10.5488 9.52403 9.77556 9.52403H8.46691L8.63143 7.61435C8.6904 7.16078 8.27508 6.83122 7.8833 7.09253ZM15.7077 7.09253C14.5102 7.89127 12.8244 9.52403 12.8244 12.0818V14.7143C12.8244 15.4244 13.4512 16 14.2244 16H17.6C18.3732 16 19 15.4244 19 14.7143V10.8097C19 10.0997 18.3732 9.52403 17.6 9.52403H16.2913L16.4559 7.61435C16.5148 7.16078 16.0995 6.83122 15.7077 7.09253Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteAlt6);
export default __webpack_public_path__ + "static/media/quote-alt-6.6819f6fbe13ce6827d72cf375f49e462.svg";
export { ForwardRef as ReactComponent };